export const imgPasswordVisible = require("../assets/ic_password_visible.png");
export const imgPasswordInVisible = require("../assets/ic_password_invisible.png");
export const imgLeftBackArrow = require("../assets/left_back_arrow.jpg");
export const defaultGroup = require("../assets/default.png");
